import $  from 'jquery';

// import debugAddInd from './../vendors/debug.addIndicators';
import gsap from './../vendors/animation.gsap';
import velocity from './../vendors/velocity.min';
//import Scene from './../vendors/animation.velocity';
import ScrollMagic from 'scrollmagic';
import TweenMax from './../vendors/TweenMax';
import lazy from './../vendors/jquery.lazy.min';
// import lazyShowPlgn from './../vendors/jquery.lazy.plugins.min';
// import iscroll from './../vendors/iscroll';
// import lettering from './../vendors/jquery.lettering-0.6.1.min';
import scrollorama from './../vendors/jquery.superscrollorama';


class marsAnimations {

  constructor() {
    this.events();

    let scrollMagicController = new ScrollMagic.Controller();

    /* Full CTA Orb */
    if ($('.fullWidth-cta__topOrb').length) {
      let scale_tween = TweenMax.from('.fullWidth-cta__topOrb', 1, {
        transform: 'scale(.75)',
        top: '-40px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".fullWidth-cta"
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }

    if ($('.fullWidth-cta__bottomOrb').length) {
      let scale_tween = TweenMax.from('.fullWidth-cta__bottomOrb', 1, {
        transform: 'scale(.75)',
        bottom: '-40px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".fullWidth-cta"
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }

    if ($('.footer-orb').length && $('.newsletter-footer__disclaimer').length) {
      let scale_tween = TweenMax.from('.footer-orb', 1, {
        transform: 'scale(.90)',
        right: '-6px',
        ease: Linear.easeNone
      });
      let scene = new ScrollMagic.Scene({
        triggerElement: ".newsletter-footer__disclaimer"
      })
        .setTween(scale_tween)
        .addTo(scrollMagicController);
    }



    /* Innovation Portrait animations */
    function initScrollAnimations() {
      let controller = $.superscrollorama();
      let screenWidth = $(window).width();
      if (screenWidth > 768) {

        $('.marketingTemplateLayout3:eq(0) .video-right').css('position', 'relative').each(function () {
          controller.addTween('.video-right', TweenMax.from($(this), 2, {
            delay: 0,
            css: {right: Math.random() * 200 - 100, top: Math.random() * 200 - 100, opacity: 0}
            //ease: Back.easeOut
          }));
        });

        $('.marketingTemplateLayout3:eq(0) .video-left').css('position', 'relative').each(function () {
          controller.addTween('.video-left', TweenMax.from($(this), 2, {
            delay: 0,
            css: {left: Math.random() * 200 - 100, top: Math.random() * 200 - 100, opacity: 0}
            //ease: Back.easeOut
          }));
        });

        // $('.marketingTemplateLayout1__content img.venture_logo, .marketingTemplateLayout2__content img.venture_logo, .marketingTemplateLayout3__content img.venture_logo').css('position', 'relative').each(function () {
        //   controller.addTween('.marketingTemplateLayout1__content img.venture_logo', TweenMax.from($(this), 3, {
        //     delay: Math.random() * .2,
        //     css: {right: Math.random() * 200 - 100, top: Math.random() * 200 - 100, opacity: 0}
        //     //ease: Back.easeOut
        //   }));
        // });

        controller.addTween('.marketingTemplateLayout3:eq(1) .video-right', TweenMax.from($('.marketingTemplateLayout3:eq(1) .video-right'), 2, {
          css: {left: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3:eq(1) .video-left', TweenMax.from($('.marketingTemplateLayout3:eq(1) .video-left'), 2, {
          css: {right: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3:eq(0) svg', TweenMax.from($('.marketingTemplateLayout3:eq(0) svg'), 2, {
          css: {left: '10px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout2__bottom_media', TweenMax.from($('.marketingTemplateLayout2__bottom_media'), 2, {
          css: {left: '1200px'},
          ease: Quad.easeInOut
        }));


        // controller.pin($('.marketingTemplateLayout1'), 3000, {
        //   anim: (new TimelineLite())
        //     .append(
        //       TweenMax.fromTo($('.marketingTemplateLayout1__bottom_media'), .75,
        //         {css:{left: -50, top: 100}, immediateRender:true},
        //         {css:{top: -50}}),
        //       -1.5 // offset for better timing
        //     )
        //     .append(
        //       TweenMax.to($('.marketingTemplateLayout1__bottom_media'), .5,
        //         {css:{left: 50}})
        //     )
        //     .append(
        //       TweenMax.to($('.marketingTemplateLayout1__bottom_media'), .5,
        //         {css:{top: 0}})
        //     )
        //     .append(
        //       TweenMax.to($('.marketingTemplateLayout1__bottom_media'), .5,
        //         {css:{left: 0}})
        //     )
        // })

        controller.addTween(
          '.marketingTemplateLayout1__right:eq(1)',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingTemplateLayout1__bottom_media-video'), 2,
                {css: {'margin-top': -10}, immediateRender: true},
                {css: {'margin-top': 150}})
              // TweenMax.fromTo($('.marketingTemplateLayout1__bottom_media'), 1,
              //   {css:{top: 500}, immediateRender:true},
              //   {css:{top: -1250}})
            ]),
          1000 // scroll duration of tween
        );

        /* Init Parallax */
        controller.addTween(
          '.marketingTemplateLayout2:eq(0)',
          (new TimelineLite())
            .append([
              // TweenMax.fromTo($('.marketingTemplateLayout2__top'), 3,
              //   {css: {'margin-top': -50}, immediateRender: true},
              //   {css: {'margin-top': 0}}),
              TweenMax.fromTo($('.marketingTemplateLayout2__bottom_media-img'), 2,
                {css: {'margin-top': -10}, immediateRender: true},
                {css: {'margin-top': 0}})
            ]),
          1000 // scroll duration of tween
        );

        controller.addTween(
          '.marketingTemplateLayout2:eq(1)',
          (new TimelineLite())
            .append([
              // TweenMax.fromTo($('.marketingTemplateLayout2__top'), 3,
              //   {css: {'margin-top': 150}, immediateRender: true},
              //   {css: {'margin-top': -10}}),
              TweenMax.fromTo($('.marketingTemplateLayout2__bottom_media-img'), 2,
                {css: {'margin-top': -100}, immediateRender: true},
                {css: {'margin-top': 0}})
            ]),
          1000 // scroll duration of tween
        );

        controller.addTween(
          '.marketingHeader',
          (new TimelineLite())
            .append([
              TweenMax.fromTo($('.marketingHeader__arrow'), 1,
                {css: {'margin-top': 0}, immediateRender: true},
                {css: {'margin-top': 200}}),
            ]),
          1000 // scroll duration of tween
        );


        $('.marketingTemplateLayout1:eq(0) .marketingTemplateLayout1__media, .marketingTemplateLayout1:eq(1) .marketingTemplateLayout1__media').css('position', 'relative').each(function () {
          controller.addTween('.marketingTemplateLayout1__media', TweenMax.from($(this), 2, {
            delay: 0,
            css: {left: 0, top: 40, opacity: 0},
            //css: {left: Math.random() * 300 - 100, top: Math.random() * 300 - 100, opacity: 0},
            ease: Back.easeOut
          }));
        });

        // $('.marketingTemplateLayout1__bottom_media').css('position', 'relative').each(function () {
        //   controller.addTween('.marketingTemplateLayout1__bottom_media', TweenMax.from($(this), 1, {
        //     delay: 0,
        //     css: {left: 0, top: 40, opacity: 0},
        //     //ease: Back.easeOut
        //   }));
        // });

        /* Backgrounds */
        controller.addTween('.marketingTemplateLayout1__background.solid', TweenMax.from($('.marketingTemplateLayout1__background.solid'), 2, {css: {opacity: 0}}));
        controller.addTween('.marketingTemplateLayout2__background.solid', TweenMax.from($('.marketingTemplateLayout2__background.solid'), 3, {
          css: {
            right: '-200px',
            top: '100px'
          }, ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout3__background.solid', TweenMax.from($('.marketingTemplateLayout3__background.solid'), 2, {
          css: {right: '1000px'},
          ease: Quad.easeInOut
        }));
        controller.addTween('.marketingTemplateLayout1__background.img', TweenMax.fromTo($('.marketingTemplateLayout1__background.img'), 2, {
          css: {
            opacity: 0,
            backgroundSize: '65%',
            left: '-200px'
          }, immediateRender: true, ease: Quad.easeInOut
        }, {css: {opacity: 1, backgroundSize: 'contain', left: '0px'}, ease: Quad.easeInOut}));
      }
    }

    initScrollAnimations();

    /* Animate on page load */
    /*
     if (document.readyState === "interactive" || document.readyState === "complete") {
        resolve();
     } else {
        window.addEventListener("DOMContentLoaded", resolve);
     }

     // Initialize your app
     function resolve() {
       document.body.removeAttribute("unresolved");
       TweenMax.from("#mars-wrapper", 1, {
          opacity: 0,
          y: 50
       });
     }
     */




    // let o = {};
    //
    // o.fade = function (e) {
    //   let t = parseInt($(e).data("enter-delay")) / 1e3 || 0;
    //   return (new TimelineMax).from(e, .5, {delay: t, opacity: 0, y: 50})
    // }
    //
    // $("[data-enter]").each(function () {
    //   window.scrollController = window.scrollController || new ScrollMagic.Controller;
    //   let e = $(this)[0], t = $(this).data("enter"), a = o[t];
    //   if (a) {
    //     let n = a(e);
    //     new ScrollMagic.Scene({triggerElement: e, triggerHook: 1}).setTween(n).addTo(window.scrollController)
    //   } else console.error('Tween "' + t + '" not defined.')
    //
    //   console.log('hits');
    // })



    /* Animate Background */
    /*
    TweenMax.fromTo('.homepage_slider__bgImage', 10, {
      backgroundSize: function(i, e) { //I use a function-based value so that it works with multiple targets and so that it grabs the value EXACTLY at the time the tween starts.
        return getBGSize(e);
      }
    }, {
      backgroundSize: "600px 500px",
      yoyo: true,
      repeat: -1,
      delay: 1,
      ease: Power1.easeInOut
    });


    function getBGSize(element, setInPx) {
      let e = (typeof(element) === "string") ? document.querySelector(element) : element,
        cs = window.getComputedStyle(e),
        imageUrl = cs.backgroundImage,
        size = cs.backgroundSize,
        image, w, h, iw, ih, ew, eh, ratio;
      if (imageUrl && !/\d/g.test(size)) {
        image = new Image();
        image.setAttribute("src", imageUrl.replace(/(^url\("|^url\('|^url\(|"\)$|'\)$|\)$)/gi, "")); //remove any url() wrapper. Note: some browsers include quotes, some don't.
        iw = image.naturalWidth;
        ih = image.naturalHeight;
        ratio = iw / ih;
        ew = e.offsetWidth;
        eh = e.offsetHeight;
        if (!iw || !ih) {
          console.log("getBGSize() failed; image hasn't loaded yet.");
        }
        //simplified/shorter version of above logic
        if (size === "cover" || size === "contain") {
          if ((size === "cover") === (iw / ew > ih / eh)) {
            h = eh;
            w = eh * ratio;
          } else {
            w = ew;
            h = ew / ratio;
          }
        } else { //"auto"
          w = iw;
          h = ih;
        }
        size = Math.ceil(w) + "px " + Math.ceil(h) + "px";
        if (setInPx) {
          e.style.backgroundSize = size;
        }
      }
      return size;
    }
    */




    /* LazyLoad images */
    $('.delay-img').lazy({
      scrollDirection: 'both',
      effect: 'fadeIn',
      effectTime: 1000,
      visibleOnly: true
    });


    //    this.bgImage = $('.homepage_slider__bgImage');
    //    this.animateBgImage();

  }

  events() {

    /* Scroll to next layout */
    $('.pageHeader__arrow-down, .pageHeaderSlider__arrow-down').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $(".sectionWrapper").offset().top}, 500, 'linear');
    });


    /* Animate in on scroll */
    /*
     const $log = document.querySelector('.log');

     //const $copy = document.querySelector('.newsletter-footer__content');
    const $copy = document.querySelector('.front');

     const test = { val: 0 };
     const t = new TweenLite(test, 10, {
     val: 1,
     ease: Linear.easeNone,
     paused: true,
     onUpdate: handleScroll
     });

     function handleScroll() {
     //console.log(test.val);
     }

     document.addEventListener('scroll', function() {
     const y = window.scrollY;

     // transitions have a start and a duration
     // at 200px, transition for 300px;
     const start = 200;
     const duration = 900;

     const progress = Math.min(1, Math.max(0, (y - start) / duration));

     //$log.innerHTML = `${y} : ${progress.toFixed(2)} : ${test.val.toFixed(2)}`;

     new TweenLite($copy, 1, {
     opacity: progress,
     y: 200 * (1 - progress)
     });

     // console.log('SET PROGRESS');
      t.progress(progress);
     }); */




    /* Animate and fade in elements on scroll */
     let o = {};

     o.fade = function (e) {
     let t = parseInt($(e).data("enter-delay")) / 1e3 || 0;
     return (new TimelineMax).from(e, .5, {delay: t, opacity: 0, y: 50})
     }

     function i() {
     $("[data-enter]").each(function () {
     window.scrollController = window.scrollController || new ScrollMagic.Controller;
     let e = $(this)[0], t = $(this).data("enter"), a = o[t];
     if (a) {
     let n = a(e);
     new ScrollMagic.Scene({triggerElement: e, triggerHook: 1}).setTween(n).addTo(window.scrollController)
     } else console.error('Tween "' + t + '" not defined.')
     })
     }
     i();

  }




  //   animateBgImage(){
  //     let scrollMagicController = new ScrollMagic.Controller();
  //     if ($(this.bgImage).length) {
  //       let scale_tween = TweenMax.fromTo(".homepage_slider__bgImage", 15,
  //         { 'background-size': '100% 100%' },
  //         { 'background-size': '110% 110%', repeat: -1, yoyo: true, ease: Sine.easeInOut }
  //       );

  //       let scene = new ScrollMagic.Scene({
  //         triggerElement: ".homepage_slider"
  //       })
  //         .setTween(scale_tween)
  //         .addTo(scrollMagicController);
  //     }
  //   }

}

export default marsAnimations;